import type { LayoutChangeEvent } from 'react-native';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { colors } from '../theme';
import { inter400, inter500, isWeb } from '../utils/platform';

type AboutSectionProps = {
  onLayout: (event: LayoutChangeEvent) => void;
  onPressTitle: () => void;
};

export function AboutSection({ onLayout, onPressTitle }: AboutSectionProps) {
  return (
    <View nativeID="about" onLayout={onLayout} style={styles.aboutSection}>
      <Pressable onPress={onPressTitle} style={styles.sectionTitleLink}>
        <Text style={styles.sectionTitle}>About me</Text>
      </Pressable>

      <View style={styles.aboutCopy}>
        <Text style={styles.paragraph}>
          Hello, I'm Alex, React Native developer with 8 years of expertise in crafting production
          grade mobile applications.
        </Text>
        <Text style={[styles.paragraph, styles.paragraphSpacing]}>
          What started as curiosity about how apps work turned into 8 years of crafting mobile
          experiences used by hundreds of thousands. I've worked across startups and established
          teams, always focused on clean code, reliable testing, and animations that delight.
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  aboutSection: {
    paddingBottom: 30,
    paddingTop: 60,
  },
  sectionTitleLink: {
    alignSelf: 'flex-start',
    ...(isWeb
      ? {
        cursor: 'pointer',
      }
      : null),
  },
  sectionTitle: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 24,
  },
  aboutCopy: {
    marginTop: 32,
  },
  paragraph: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 22.4,
  },
  paragraphSpacing: {
    marginTop: 20,
  },
});
